export namespace GasIcon {
  export enum Notifications {
    Warning = 'notifications-warning',
    LightWarning = 'notifications-light-warning',
    Error = 'notifications-error',
    LightError = 'notifications-light-error',
    General = 'notifications-general',
    LightGeneral = 'notifications-light-general',
    Success = 'notifications-success',
    LightSuccess = 'notifications-light-success',
    Close = 'notifications-close',
    LightClose = 'notifications-light-close',
    Arrow = 'notifications-arrow',
    UploadSuccess = 'notifications-upload-success',
    UploadError = 'notifications-upload-error',
    AgentSession = 'notifications-agent-session',
    Announcement = 'notifications-announcement',
    Answer = 'notifications-answer',
    AnsweredTwice = 'notifications-answered-twice',
    Ban = 'notifications-ban',
    Chat = 'notifications-chat',
    Comments = 'notifications-comments',
    ContactRequest = 'notifications-contact-request',
    Email = 'notifications-email',
    EmailOpen = 'notifications-email-open',
    EndChat = 'notifications-end-chat',
    EndMessagingSession = 'notifications-end-messaging-session',
    Engage = 'notifications-engage',
    Events = 'notifications-events',
    ReportIssue = 'notifications-report-issue',
    RetailExecution = 'notifications-retail-execution',
    MessagePlusAlt = 'notifications-message-plus-alt',
  }

  export enum Core {
    Check = 'core-check',
    CellChecked = 'core-cell-checked',
    Checker = 'core-checker',
    Required = 'core-required',
    Search = 'core-search',
    Back = 'core-back',
    Settings = 'core-settings',
    Automate = 'core-automate',
    Broadcast = 'core-broadcast',
    ComponentCustomization = 'core-component-customization',
    CustomApps = 'core-custom-apps',
    Hide = 'core-hide',
  }

  export enum Actions {
    Files = 'actions-file',
    Layers = 'actions-layers',
    Success = 'actions-success',
    Info = 'actions-info',
    InfoReverse = 'actions-info-reverse',
    Refresh = 'actions-refresh',
    UploadFile = 'actions-upload-file',
    UploadHelper = 'actions-upload-helper',
    Launch = 'actions-launch',
    Logout = 'actions-logout',
    Slider = 'actions-slider',
    Add = 'actions-add',
    AddUser = 'actions-add-user',
    Assignment = 'actions-assignment',
    Attach = 'actions-attach',
    BlockVisitor = 'actions-block-visitor',
    ButtonChoice = 'actions-button-choice',
    Call = 'actions-call',
    CancelFileRequest = 'actions-cancel-file-request',
    CancelTransfer = 'actions-cancel-transfer',
    Cases = 'actions-cases',
    ChangeOwner = 'actions-change-owner',
    ChangeRecordType = 'actions-change-record-type',
    Clear = 'actions-clear',
    Copy = 'actions-copy',
    CopyClipboard = 'actions-copy-clipboard',
    Cut = 'actions-cut',
    Delete = 'actions-delete',
    Deprecate = 'actions-deprecate',
    Dialing = 'actions-dialing',
    Dislike = 'actions-dislike',
    Download = 'actions-download',
    Drag = 'actions-drag',
    DragAndDrop = 'actions-drag-and-drop',
    Edit = 'actions-edit',
    EditForm = 'actions-edit-form',
    EndCall = 'actions-end-call',
    Help = 'actions-help',
    LeaveConference = 'actions-leave-conference',
    MinimizeWindow = 'actions-minimize-window',
    OpenFolder = 'actions-open-folder',
    Package = 'actions-package',
    PackageOrg = 'actions-package-org',
    PackageOrgBeta = 'actions-package-org-beta',
    Paste = 'actions-paste',
    Pause = 'actions-pause',
    Play = 'actions-play',
    Print = 'actions-print',
    Push = 'actions-push',
    Record = 'actions-record',
    RecordCreate = 'actions-record-create',
    RecordDelete = 'actions-record-delete',
    RecordLookup = 'actions-record-lookup',
    RecordUpdate = 'actions-record-update',
    Relate = 'actions-relate',
    RemoveFormatting = 'actions-remove-formatting',
    RemoveLink = 'actions-remove-link',
    Replace = 'actions-replace',
    ResetPassword = 'actions-reset-password',
    Save = 'actions-save',
    Send = 'actions-send',
    Setup = 'actions-setup',
    Share = 'actions-share',
    ShareFile = 'actions-share-file',
    ShareMobile = 'actions-share-mobile',
    Stop = 'actions-stop',
    TurnOffNotifications = 'actions-turn-off-notifications',
    Undelete = 'actions-undelete',
    Upload = 'actions-upload',
    Logout1 = 'actions-logout1',
    NewWindow = 'actions-new-window',
    DownloadPdf = 'actions-download-pdf',
    OpenDocument = 'actions-open-document',
  }

  export enum Arrows {
    ChevronUp = 'arrows-chevron-up',
    ChevronDown = 'arrows-chevron-down',
    ChevronRight = 'arrows-chevron-right',
    Up = 'arrows-up',
    Down = 'arrows-down',
    SmallRight = 'arrows-small-right',
    SmallLeft = 'arrows-small-left',
    SmallUp = 'arrows-small-up',
    SmallDown = 'arrows-small-down',
    Right = 'arrows-right',
    Left = 'arrows-left',
    MicroDown = 'arrows-micro-down',
    More = 'arrows-more',
    Apex = 'arrows-apex',
    Breadcrumbs = 'arrows-breadcrumbs',
    Capslock = 'arrows-capslock',
    Contract = 'arrows-contract',
    ContractAlt = 'arrows-contract-alt',
    Enter = 'arrows-enter',
    Expand = 'arrows-expand',
    ExpandAlt = 'arrows-expand-alt',
    ForwardUp = 'arrows-forward-up',
    HighVelositySales = 'arrows-high-velocity-sales',
    LevelDown = 'arrows-level-down',
    LevelUp = 'arrows-level-up',
    Loop = 'arrows-loop',
    Macros = 'arrows-macros',
    Merge = 'arrows-merge',
    Move = 'arrows-move',
    Open = 'arrows-open',
    Redo = 'arrows-redo',
    Refresh = 'arrows-refresh',
    Reply = 'arrows-reply',
    ReplyAll = 'arrows-reply-all',
    Retweet = 'arrows-retweet',
    Rotate = 'arrows-rotate',
    Shortcuts = 'arrows-shortcuts',
    Skip = 'arrows-skip',
    SkipBack = 'arrows-skip-back',
    SkipForward = 'arrows-skip-forward',
    Sort = 'arrows-sort',
    Sync = 'arrows-sync',
    Undo = 'arrows-undo',
  }

  export enum Layout {
    Success = 'layout-success',
    Navigation = 'layout-navigation',
    Crum = 'layout-crum',
    Lightning = 'layout-lightning',
    Eye = 'layout-eye',
    Calendar = 'layout-calendar',
    Settings = 'layout-settings',
    Important = 'layout-important',
    Polling = 'layout-polling',
  }

  export enum Common {
    ProgressXxl = 'common-progress-xxl',
    ProgressBg = 'common-progress-xlg',
    ProgressLarge = 'common-progress-lg',
    ProgressSmall = 'common-progress-sm',
    Lightning = 'common-lightning',
    Panel = 'common-panel',
    Required = 'common-required',
    CellChecked = 'common-cell-checked',
    Date = 'common-date',
    DateView = 'common-date-view',
    DateTime = 'common-date-time',
    Ball = 'common-ball',
    FilterList = 'common-filter-list',
    Search = 'common-search',
    StrokeBall = 'common-stroke-ball',
    Clock = 'common-clock',
    Message = 'common-message',
    Help = 'common-help',
    AdvancedFunction = 'common-advanced-function',
    Adset = 'common-ad-set',
    AllFigure = 'common-all-figure',
    Anchor = 'common-anchor',
    AnimalAndNature = 'common-animal-and-nature',
    APexPlugin = 'common-apex-plugin',
    Approval = 'common-approval',
    Away = 'common-away',
    ActivityBall = 'common-activity-ball',
    Bold = 'common-bold',
    Bookmark = 'common-bookmark',
    Brush = 'common-brush',
    Bucket = 'common-bucket',
    Campaign = 'common-campaign',
    Cart = 'common-cart',
    Chart = 'common-chart',
    Choice = 'common-choice',
    CLassicInterface = 'common-classic-interface',
    CollectionVariable = 'common-collection-variable',
    ColorsSwatch = 'common-colors-swatch',
    ConnectedApps = 'common-connected-apps',
    Constants = 'common-constants',
    Crossfilter = 'common-crossfilter',
    Currency = 'common-currency',
    CurrencyInput = 'common-currency-input',
    Dash = 'common-dash',
    DataDotcom = 'common-datadotcom',
    Description = 'common-description',
    Desctop = 'common-desctop',
    DesctopANdPhone = 'common-desctop-and-phone',
    DesctopConsole = 'common-desctop-console',
    Diamond = 'common-diamond',
    DisplayRichText = 'common-aisplay-rich-text',
    DisplayText = 'common-aisplay-text',
    DynamicRecordChoice = 'common-dynamic-record-choice',
    Education = 'common-education',
    Enstain = 'common-enstain',
    Emoji = 'common-emoji',
    ErectWindow = 'common-erect-window',
    Event = 'common-event',
    ExpandAll = 'common-expand-all',
    Favorit = 'common-favorit',
    Feed = 'common-feed',
    Filter = 'common-filter',
    Flow = 'common-flow',
    FlowAlt = 'common-flow-alt',
    FoodAndDrink = 'common-food-and-drink',
    Formula = 'common-formula',
    Frozen = 'common-frozen',
    FulfillmentOrder = 'common-fulfillment-order',
    FullWidthView = 'common-full-width-view',
    GlobalConstants = 'common-global-constants',
    Group = 'common-group',
    HelpCenter = 'common-help-center',
    HideMobile = 'common-hide-mobile',
    KeyboardDismiss = 'common-keyboard-dismiss',
    KnowledgeBase = 'common-knowledge-base',
    Layers = 'common-layers',
    LayoutCommon = 'common-layout',
    LeftAlignText = 'common-left-align-text',
    RightAlignText = 'common-right-align-text',
    LightningExtension = 'common-lightning-extension',
    LightningInspector = 'common-lightning-inspector',
    LightningBulb = 'common-lightning-bulb',
    Like = 'common-like',
    Link = 'common-link',
    Linked = 'common-linked',
    List = 'common-list',
    Listen = 'common-listen',
    LiveMessage = 'common-live-message',
    Location = 'common-location',
    Lock = 'common-lock',
    LockerServiceApiViewer = 'common-locker-service-api-viewer',
    LockerServiceConsole = 'common-locker-service-console',
    LogACall = 'common-log-a-call',
    LowerFlag = 'common-lower-flag',
    Magicwand = 'common-magicwand',
    MarkAllAsRead = 'common-mark-all-as-read',
    Matrix = 'common-matrix',
    MergeField = 'common-merge-field',
    Metrics = 'common-metrics',
    MissedCall = 'common-missed-call',
    Money = 'common-money',
    Moneybag = 'common-moneybag',
    Monthlyview = 'common-monthlyview',
    MultiPicklist = 'common-multi-picklist',
    MultiSelectCheckbox = 'common-multi-select-checkbox',
    Muted = 'common-muted',
    New = 'common-new',
    News = 'common-news',
    NewDirectMessage = 'common-new-direct-message',
    Note = 'common-note',
    Notebook = 'common-notebook',
    Notification = 'common-notification',
    NumberInput = 'common-number-input',
    Office365 = 'common-office365',
    Offline = 'common-offline',
    OfflineCached = 'common-offline-cached',
    OmniChannel = 'common-omni-channel',
    OpenedFolder = 'common-opened-folder',
    OutboundCall = 'common-outbound-call',
    Outcome = 'common-outcome',
    Overflow = 'common-overflow',
    Page = 'common-page',
    Palette = 'common-palette',
    Password = 'common-password',
    People = 'common-people',
    PhoneLandscape = 'common-phone-landscape',
    PhonePortrait = 'common-phone-portrait',
    TabletLandscape = 'common-tablet-landscape',
    TabletPortrait = 'common-tablet-portrait',
    Photo = 'common-photo',
    Picklist = 'common-picklist',
    PicklistChoice = 'common-picklist-choice',
    PicklistType = 'common-picklist-type',
    Pin = 'common-pin',
    Pinned = 'common-pinned',
    PodcastWebinar = 'common-podcast-webinar',
    PopIn = 'common-pop-in',
    Power = 'common-power',
    Preview = 'common-preview',
    Priority = 'common-priority',
    PrivatelyShared = 'common-privately-shared',
    Process = 'common-process',
    Prompt = 'common-prompt',
    PromptEdit = 'common-prompt-edit',
    Puzzle = 'common-puzzle',
    Question = 'common-question',
    QuestionsAndAnswers = 'common-questions-and-answers',
    QuestionMark = 'common-question-mark',
    QuickText = 'common-quick-text',
    Quip = 'common-quip',
    QuotationMarks = 'common-quotation-marks',
    Quote = 'common-quote',
    RadioButton = 'common-radio-button',
    Rating = 'common-rating',
    Reassing = 'common-reassign',
    RecurringException = 'common-recurring-exception',
    RecycleBinEmpty = 'common-recycle-bin-empty',
    RecycleBinFull = 'common-recycle-bin-full',
    Reminder = 'common-reminder',
    ResourceAbsence = 'common-resource-absence',
    ResourceCapacity = 'common-resource-capacity',
    ResourceTerritory = 'common-resource-territory',
    Ribbon = 'common-ribbon',
    Richtextbulletedlist = 'common-richtextbulletedlist',
    Richtextindent = 'common-richtextindent',
    Richtextnumberedlist = 'common-richtextnumberedlist',
    Richtextoutdent = 'common-richtextoutdent',
    RoutingOffline = 'common-routing-offline',
    Rows = 'common-rows',
    Rules = 'common-rules',
    Salesforce = 'common-salesforce1',
    Screen = 'common-screen',
    Section = 'common-section',
    SentimentNegative = 'common-sentiment-negative',
    SentimentNeutral = 'common-sentiment-neutral',
    SmileyAndPeople = 'common-smiley-and-people',
    Settings = 'common-settings',
    SetupAssistantGuide = 'common-setup-assistant-guide',
    SetupModal = 'common-setup-modal',
    SharePost = 'common-share-post',
    Shield = 'common-shield',
    ShiftUi = 'common-shift-ui',
    ShoppingBag = 'common-shopping-bag',
    SideList = 'common-side-list',
    Signpost = 'common-signpost',
    Slider = 'common-slider',
    Sms = 'common-sms',
    Snippet = 'common-snippet',
    Sobject = 'common-sobject',
    SobjectCollection = 'common-sobject-collection',
    Socialshare = 'common-socialshare',
    Spinner = 'common-spinner',
    Stage = 'common-stage',
    StageCollection = 'common-stage-collection',
    StandartObjects = 'common-standard-objects',
    Steps = 'common-steps',
    Store = 'common-store',
    Strategy = 'common-strategy',
    Strikethrough = 'common-strikethrough',
    Success = 'common-success',
    Summary = 'common-summary',
    SummaryDetail = 'common-summarydetail',
    Survey = 'common-survey',
    Switch = 'common-switch',
    Symbols = 'common-symbols',
    SystemAndGlobalVariable = 'common-system-and-global-variable',
    Table = 'common-table',
    TableSettings = 'common-table-settings',
    Tabset = 'common-tabset',
    Target = 'common-target',
    Task = 'common-task',
    Text = 'common-text',
    Textarea = 'common-textarea',
    Textbox = 'common-textbox',
    TextBackgroundColor = 'common-text-background-color',
    TextColor = 'common-text-color',
    TextTemplate = 'common-text-template',
    ThreeDots = 'common-threedots',
    ThreeDotsVertical = 'common-threedots-vertical',
    Thunder = 'common-thunder',
    TitleCardList = 'common-tile-card-list',
    Toggle = 'common-toggle',
    TogglePanelBottom = 'common-toggle-panel-bottom',
    TogglePanelLeft = 'common-toggle-panel-left',
    TogglePanelRight = 'common-toggle-panel-right',
    TogglePanelTop = 'common-toggle-panel-top',
    Topic = 'common-topic',
    Topic2 = 'common-topic2',
    TouchAction = 'common-touch-action',
    Tracker = 'common-tracker',
    Trail = 'common-trail',
    Trailhead = 'common-trailhead',
    TravelAndPlaces = 'common-travel-and-places',
    Trending = 'common-trending',
    Type = 'common-type',
    TypeTool = 'common-type-tool',
    Undeprecate = 'common-undeprecate',
    Underline = 'common-underline',
    Unlinked = 'common-unlinked',
    Unlock = 'common-unlock',
    Unmuted = 'common-unmuted',
    User = 'common-user',
    UserRole = 'common-user-role',
    Variable = 'common-variable',
    Video = 'common-video',
    VoicemailDrop = 'common-voicemail-drop',
    VolumeHigh = 'common-volume-high',
    VolumeLow = 'common-volume-low',
    VolumeOff = 'common-volume-off',
    Waits = 'common-waits',
    Warning = 'common-warning',
    Watchlist = 'common-watchlist',
    Weeklyview = 'common-weeklyview',
    Wifi = 'common-wifi',
    WorkOrderType = 'common-work-order-type',
    World = 'common-world',
    YubiKey = 'common-yubi-key',
    Zoomin = 'common-zoomin',
    Zoomout = 'common-zoomout',
  }

  export enum Navigation {
    Burger = 'navigation-burger',
    CenterAlignText = 'navigation-canter-align-text',
    Back = 'navigation-back',
    Electors = 'navigation-electors',
    Deg = 'navigation-deg',
    Home = 'navigation-home',
    File = 'navigation-file',
    ArrowTo = 'navigation-arrow-to',
    Copy = 'navigation-copy',
    Send = 'navigation-send',
    IdCard = 'navigation-id-card',
    Group = 'navigation-group',
    Advertising = 'navigation-advertising',
    CollapseAll = 'navigation-collapse-all',
    GroupAll = 'navigation-group-all',
  }

  export enum Menu {
    Home = 'menu-home',
    Search = 'menu-search',
    Database = 'menu-database',
    Manage = 'menu-manage',
    Task = 'menu-task',
    World = 'menu-world',
    Case = 'menu-case',
    File = 'menu-file',
    Graph = 'menu-graph',
    Refresh = 'menu-refresh',
    Settings = 'menu-settings',
    Apps = 'menu-apps',
    Archive = 'menu-archive',
    Builder = 'menu-builder',
    Checkin = 'menu-checkin',
    Company = 'menu-company',
    Hierarchy = 'menu-hierarchy',
  }

  export type Icons = GasIcon.Notifications
    | GasIcon.Layout
    | GasIcon.Actions
    | GasIcon.Arrows
    | GasIcon.Core
    | GasIcon.Common
    | GasIcon.Navigation
    | GasIcon.Menu;
}
